/**
 * @version 1.0
 * @author xieyq
 * @createTime 2021/9/2
 * @updateTime 2021/9/2
 * @decription 申请担保-编辑财产线索模块
 */
// 表单布局
import acLayoutForm from '@/components/app/layout/form/index.vue';
// 标题栏
import acTitleBar from '@/components/app/title-bar/index.vue';
import {
    typeBz, typeCar,
    typeSF,
    typeTddw
} from '@/filters/index';
import validate from '@/utils/validator/validator';
import {
    cclxRule,
    ccsyrRule,
    CzjzRule,
    SexzRule,
    bzRule,
    khhmcRule,
    KhyhmcRule,
    KhyhzhRule,
    clgsdRule,
    ClppRule,
    CphRule,
    fwzlRule,
    FwzlwzRule,
    FczhRule,
    tdgsRule,
    DzhqsRule,
    TdmjRule,
    CqzhRule,
    tddwRule,
    fxdwRule,
    GpmcRule, GpdmRule, CgslRule, JjmcRule, JjslRule, ZqmcRule, ZqmzRule, CggsmcRule, CzblRule, CsbmcRule, MsRule
} from '@/utils/validator/rules';
import {createId} from "@/utils/common";
import {mapGetters} from "vuex";

export default {
    components: {
        acLayoutForm,
        acTitleBar
    },
    props: {
        // 被申请人数据列表
        bsqrDataList: Array,
        // 表单数据
        data: Object
    },
    // 注入
    inject: ['fromSQBG'],
    data() {
        return {
            // 表单数据
            formData: {
                // 财产类型
                cCclx: '4',
                // 财产类型
                cCclxText: '房产',
                // 财产拥有者文字姓名
                cSqdbccyyz: "",
                // 财产所有者名称
                cSqdbccyyzText: '',
                // 申请保全财产金额
                cSqbqccje: "",
                // 开户银行名称
                cKhhmc: "",
                // 开户账号
                cYhckzkhzh: '',
                // 币种类型文本
                cCclxzbz: "",
                // 币种类型文本
                cCclxzbzText: '',
                // 现金金额
                cXjzje: "",
                // 开户数额
                cYhckzckje: '',
                // 单位
                cYhckzckdw: '',
                // 单位文本
                cYhckzckdwText: '',
                // 土地归属地地址
                cCclxtdddz: '',
                // 面积
                cCclxtdmj: '',
                // 产权证号
                cCclxtddcqzh: '',
                // 房屋坐落位置
                cCclxfcdz: '',
                // 房产证号
                cCclxfczh: '',
                // 车辆品牌
                cCclxzclpp: "",
                // 车辆类型
                cCclxcllx: "",
                // 车辆类型文本
                cCclxcllxText: "",
                // 车牌号
                cCklxzcldcph: "",
                // 债券名称
                cCclxzzwdzqmc: '',
                // 持股公司名称
                cCclxzgqdcggs: '',
                // 债券面值(元)
                cCclxzzwdzqmz: '',
                cCclxzzwdzqmzTS: "",
                // 描述
                cMs: '',
                // 设备名称
                cSbmc: '',
                // 股票代码
                cCclxzgqdgsxx: '',
                // 基金名称
                cCclxzjjdjjmc: '',
                // 基金数量(份)
                cCclxzjjdjjsl: '',
                // 股票名称
                cCclxzgpdgpmc: '',
                // 持股数量(股)
                cCclxzgpdcgsl: '',
                // 出资比例(%)
                cCclxzgqdczbl: '',
                // 归属地
                cGsd: '',
                // 归属地文本
                cGsdText: ''
            },
            // 材料类型弹窗
            showCCLX: false,
            // 是否显示财产所有人
            showCCSYR: false,
            // 被申请人数据列表
            columnsBSQRS: this.bsqrDataList,
            // 币种类型
            showBZLX: false,
            // 显示归属地
            showGsd: false,
            // 车辆类型
            showCLLX: false,
            // 土地单位类型
            showTDDW: false
        }
    },
    computed: {
        // 财产类型、币种类型、省份、车辆类型、单位
        ...mapGetters(['codeList_112000', 'codeList_119000', 'codeList_805000', 'codeList_132000', 'codeList_131000'])
    },
    methods: {

        // 返回
        back() {
            this.$emit('cancel');
        },

        /**
         * 切换材料类型需要清空表单数据
         * @returns {void}
         * */
        clearCCXSData: function () {
            // 清空对应的数据
            this.formData = {
                ...this.formData,
                ...this.resetData
            }
        },

        /**
         * 选择财产类型
         * @param {Object} item 选中的信息项
         * @returns {void}
         * */
        onCCLXConfirm: function (item) {
            this.showCCLX = false;
            // 如果选择的是相同的，则不需要往下走
            if (this.formData.cCclx === item.keyId) {
                return;
            }
            // 清空表单数据
            this.clearCCXSData();
            // 土地使用权
            if (item.keyId == 5) {
                // 单位
                this.formData.cYhckzckdw = 1;
                this.formData.cYhckzckdwText = "平方米";
            }
            // 赋值财产类型数据
            this.formData.cCclx = item.keyId;
            this.formData.cCclxText = item.text;
        },

        /**
         * 选择财产所有人
         * @param {Object} item 选中的信息项
         * @returns {void}
         * */
        onCCSYRConfirm: function (item) {
            this.formData.cSqdbccyyz = item.keyId;
            this.formData.cSqdbccyyzText = item.text;
            this.showCCSYR = false;
        },

        /**
         * 选择币种类型
         * @param {Object} item 选中的信息项
         * @returns {void}
         * */
        onBZConfirm(item) {
            this.showBZLX = false;
            this.formData.cCclxzbz = item.keyId;
            this.formData.cCclxzbzText = item.text;
        },

        /**
         * 选择归属地
         * @param {Object} item 选中的信息项
         * @returns {void}
         * */
        confirmGsd(item) {
            this.showGsd = false;
            this.formData.cGsd = item.keyId;
            this.formData.cGsdText = item.text;
        },

        /**
         * 选择车辆类型
         * @param {Object} item 选中的信息项
         * @returns {void}
         * */
        onCLLXConfirm(item) {
            this.showCLLX = false;
            this.formData.cCclxcllx = item.keyId;
            this.formData.cCclxcllxText = item.text;
        },

        /**
         * 选择土地单位类型
         * @param {Object} item 选中的信息项
         * @returns {void}
         * */
        onTDDWLXConfirm(item) {
            this.showTDDW = false;
            this.formData.cYhckzckdw = item.keyId;
            this.formData.cYhckzckdwText = item.text;
        },

        /**
         * 添加/确认按钮点击事件
         * @returns {void}
         * */
        addAndReturn() {
            // 验证表单
            this.validateFormData().then(() => {
                // 向上分发确认事件
                this.$emit('confirm', this.formData);
            }).catch(() => {
                console.log('校验不通过！');
            });
        },

        /**
         * 重置数据
         * */
        reset() {
            // 重置数据
            this.formData = {
                // 财产类型
                cCclx: '4',
                // 财产类型
                cCclxText: '房产',
                // 财产拥有者文字姓名
                cSqdbccyyz: "",
                // 财产所有者名称
                cSqdbccyyzText: '',
                // 申请保全财产金额
                cSqbqccje: "",
                // 开户银行名称
                cKhhmc: "",
                // 开户账号
                cYhckzkhzh: '',
                // 币种类型文本
                cCclxzbz: "",
                // 币种类型文本
                cCclxzbzText: '',
                // 现金金额
                cXjzje: "",
                // 开户数额
                cYhckzckje: '',
                // 单位
                cYhckzckdw: '',
                // 单位文本
                cYhckzckdwText: '',
                // 土地归属地地址
                cCclxtdddz: '',
                // 面积
                cCclxtdmj: '',
                // 产权证号
                cCclxtddcqzh: '',
                // 房屋坐落位置
                cCclxfcdz: '',
                // 房产证号
                cCclxfczh: '',
                // 车辆品牌
                cCclxzclpp: "",
                // 车辆类型
                cCclxcllx: "",
                // 车辆类型文本
                cCclxcllxText: "",
                // 车牌号
                cCklxzcldcph: "",
                // 债券名称
                cCclxzzwdzqmc: '',
                // 持股公司名称
                cCclxzgqdcggs: '',
                // 债券面值(元)
                cCclxzzwdzqmz: '',
                cCclxzzwdzqmzTS: "",
                // 描述
                cMs: '',
                // 设备名称
                cSbmc: '',
                // 股票代码
                cCclxzgqdgsxx: '',
                // 基金名称
                cCclxzjjdjjmc: '',
                // 基金数量(份)
                cCclxzjjdjjsl: '',
                // 股票名称
                cCclxzgpdgpmc: '',
                // 持股数量(股)
                cCclxzgpdcgsl: '',
                // 出资比例(%)
                cCclxzgqdczbl: '',
                // 归属地
                cGsd: '',
                // 归属地文本
                cGsdText: ''
            };
        },

        /**
         * 刷新表单
         * */
        refresh() {
            // 重置数据
            this.reset();
            // 初始化方法
            this.init();
        },

        /**
         * 确认并添加按钮点击事件
         * @returns {void}
         * */
        addAndContinue() {
            // 验证表单数据
            this.validateFormData().then(() => {
                // 向上分发确认并继续事件
                this.$emit('confirm-continue', this.formData);
                // 刷新表单
                this.refresh();
            }).catch(() => {
                console.log('校验不通过！');
            });
        },

        /**
         * 校验form表单
         * @returns {Promise}
         * */
        validateFormData() {
            let descriptor = {
                // 财产类型
                cCclx: cclxRule,
                // 财产所有人
                cSqdbccyyz: ccsyrRule
            };
            switch (this.formData.cCclx) {
                case '1':
                    descriptor.cXjzje = new SexzRule(true);
                    descriptor.cCclxzbz = bzRule;
                    break;
                case '2':
                    descriptor.cGsd = khhmcRule;
                    descriptor.cKhhmc = new KhyhmcRule(true);
                    descriptor.cYhckzkhzh = new KhyhzhRule(true);
                    descriptor.cYhckzckje = new SexzRule(true);
                    descriptor.cCclxzbz = bzRule;
                    break;
                case '3':
                    descriptor.cGsd = clgsdRule;
                    descriptor.cCclxzclpp= new ClppRule(false);
                    descriptor.cCklxzcldcph = new CphRule(true);
                    break;
                case '4':
                    descriptor.cGsd = fwzlRule;
                    descriptor.cCclxfcdz = new FwzlwzRule(true);
                    descriptor.cCclxfczh = new FczhRule(false);
                    break;
                case '5':
                    descriptor.cGsd = tdgsRule;
                    descriptor.cCclxtdddz = new DzhqsRule(true);
                    descriptor.cCclxtdmj = new TdmjRule(true);
                    descriptor.cCclxtddcqzh = new CqzhRule(false);
                    descriptor.cYhckzckdw = tddwRule;
                    break;
                case '6':
                    descriptor.cGsd = fxdwRule;
                    // 股票名称
                    descriptor.cCclxzgpdgpmc = new GpmcRule(true);
                    // 股票代码
                    descriptor.cCclxzgqdgsxx = new GpdmRule(false);
                    // 持股数量
                    descriptor.cCclxzgpdcgsl = new CgslRule(false);
                    break;
                case '7':
                    descriptor.cGsd = fxdwRule;
                    // 基金名称
                    descriptor.cCclxzjjdjjmc = new JjmcRule(true);
                    // 基金数量
                    descriptor.cCclxzjjdjjsl = new JjslRule(false);
                    break;
                case '8':
                    descriptor.cGsd = fxdwRule;
                    descriptor.cCclxzzwdzqmc = new ZqmcRule(true);
                    descriptor.cCclxzzwdzqmz = new ZqmzRule(true);
                    break;
                case '9':
                    descriptor.cGsd = fxdwRule;
                    descriptor.cCclxzgqdcggs = new CggsmcRule(true);
                    descriptor.cCclxzgqdczbl = new CzblRule(true);
                    break;
                case '11':
                    descriptor.cSbmc = new CsbmcRule(true);
                    break;
                default:
                    descriptor.cMs = new MsRule(true);
                    break;
            }
            // 财产价值
            descriptor.cSqbqccje = new CzjzRule(true);
            if (typeof(this.formData.cSqdbccyyz) == "undefined") {
                this.$notify("没有财产所有人，请添加被申请人");
                return null;
            }
            let validated = validate(descriptor, this.formData);
            return validated;
        },

        /**
         * 初始化代码值
         * @returns {void}
         * */
        initCodeType() {
            // 证件类型
            this.$store.dispatch('GetCodeType', 112000);
            // 币种类型
            this.$store.dispatch('GetCodeType', 119000);
            // 省份
            this.$store.dispatch('GetCodeType', 805000);
            // 车辆类型
            this.$store.dispatch('GetCodeType', 132000);
            // 单位
            this.$store.dispatch('GetCodeType', 131000);
        },

        /**
         * 初始化被申请人数据列表
         * @returns {void}
         * */
        initColumnsBSQRS: function () {
            const _columnsBSQRS = [];
            this.bsqrDataList.forEach(dataItem => {
               _columnsBSQRS.push({
                   keyId: dataItem[this.fromSQBG ? 'cYdbDsrid' : 'cDbDsrid'],
                   text: dataItem.cDsrlx === '1' ? dataItem.cDsrxm : dataItem.cQymc
               });
            });
            this.columnsBSQRS = _columnsBSQRS;
        },

        /**
         * 初始化不需要更新的数据
         * @returns {void}
         * */
        initNoUpdateData() {
            // 重置数据
            this.resetData = {
                // 申请保全财产金额
                cSqbqccje: "",
                // 开户银行名称
                cKhhmc: "",
                // 开户账号
                cYhckzkhzh: '',
                // 币种类型文本
                cCclxzbz: "",
                // 币种类型文本
                cCclxzbzText: '',
                // 现金金额
                cXjzje: "",
                // 开户数额
                cYhckzckje: '',
                // 单位
                cYhckzckdw: '',
                // 单位文本
                cYhckzckdwText: '',
                // 土地归属地地址
                cCclxtdddz: '',
                // 面积
                cCclxtdmj: '',
                // 产权证号
                cCclxtddcqzh: '',
                // 房屋坐落位置
                cCclxfcdz: '',
                // 房产证号
                cCclxfczh: '',
                // 车辆品牌
                cCclxzclpp: "",
                // 车辆类型
                cCclxcllx: "",
                // 车辆类型文本
                cCclxcllxText: "",
                // 车牌号
                cCklxzcldcph: "",
                // 债券名称
                cCclxzzwdzqmc: '',
                // 持股公司名称
                cCclxzgqdcggs: '',
                // 债券面值(元)
                cCclxzzwdzqmz: '',
                cCclxzzwdzqmzTS: "",
                // 描述
                cMs: '',
                // 设备名称
                cSbmc: '',
                // 股票代码
                cCclxzgqdgsxx: '',
                // 基金名称
                cCclxzjjdjjmc: '',
                // 基金数量(份)
                cCclxzjjdjjsl: '',
                // 股票名称
                cCclxzgpdgpmc: '',
                // 持股数量(股)
                cCclxzgpdcgsl: '',
                // 出资比例(%)
                cCclxzgqdczbl: '',
                // 归属地
                cGsd: '',
                // 归属地文本
                cGsdText: ''
            };
        },

        /**
         * 初始化方法
         * @returns {void}
         * */
        init() {
            // 初始化不需要更新的数据
            this.initNoUpdateData();
            // 如果数据存在
            if (this.data) {
                // 数据进行赋值
                const _formData = {
                    ...this.data
                };
                // 归属地对应的文本
                _formData.cGsdText = typeSF(_formData.cGsd);
                // 现金单位描述
                _formData.cCclxzbzText = typeBz(_formData.cCclxzbz);
                // 车辆类型文字描述
                _formData.cCclxcllxText = typeCar(_formData.cCclxcllx);
                // 土地面积单位描述
                _formData.cYhckzckdwText = typeTddw(_formData.cYhckzckdw);
                // 表单赋值
                this.formData = _formData;
            } else {
                // 创建id
                createId().then(id => {
                    this.formData.cId = id;
                    // 设置是属于新增
                    this.formData.isAdd = true;
                });
            }
        }
    },
    created() {
        // 初始化代码值
        this.initCodeType();
        // 初始化
        this.init();
        // 初始化被申请人列表
        // this.initColumnsBSQRS();
    }
}
